<script setup>
const props = defineProps({
    isDark: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: "black",
    },
});
</script>

<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.3665 16.8526C7.27382 16.8526 5.5029 16.1277 4.05377 14.6778C2.60463 13.2279 1.87967 11.457 1.87891 9.36504C1.87814 7.27312 2.60309 5.50221 4.05377 4.0523C5.50444 2.60239 7.27535 1.87744 9.3665 1.87744C11.4577 1.87744 13.229 2.60239 14.6804 4.0523C16.1318 5.50221 16.8564 7.27312 16.8541 9.36504C16.8541 10.2098 16.7197 11.0066 16.4509 11.7553C16.1821 12.5041 15.8174 13.1664 15.3566 13.7424L21.8074 20.1933C22.0186 20.4044 22.1242 20.6732 22.1242 20.9996C22.1242 21.326 22.0186 21.5948 21.8074 21.806C21.5962 22.0172 21.3275 22.1228 21.0011 22.1228C20.6747 22.1228 20.4059 22.0172 20.1947 21.806L13.7439 15.3551C13.1679 15.8159 12.5055 16.1807 11.7568 16.4495C11.008 16.7182 10.2113 16.8526 9.3665 16.8526ZM9.3665 14.5488C10.8064 14.5488 12.0306 14.045 13.0389 13.0374C14.0472 12.0299 14.551 10.8057 14.5502 9.36504C14.5495 7.92435 14.0457 6.70061 13.0389 5.69381C12.0321 4.68702 10.808 4.18285 9.3665 4.18132C7.92505 4.17978 6.7013 4.68395 5.69528 5.69381C4.68925 6.70368 4.18509 7.92742 4.18278 9.36504C4.18048 10.8027 4.68464 12.0268 5.69528 13.0374C6.70591 14.0481 7.92965 14.5518 9.3665 14.5488Z"
            :fill="isDark ? '#FF6400' : color"
        />
    </svg>
</template>
